<template>
  <div class="footer" v-if="footerData">
    <div class="container">
      <div class="flex">
        <div class="info">
          <div v-if="footerData.phone"><i class="el-icon-phone"></i>电话：{{ footerData.phone }}</div>
          <div v-if="footerData.email"><i class="el-icon-message"></i>邮箱：{{ footerData.email }}</div>
          <div v-if="footerData.address"><i class="el-icon-location-information"></i>地址：{{ footerData.address }}</div>
        </div>
        <div class="other center" v-if="footerData.icp">
          <div class="flex-center">
            <img class="img" src="@/assets/beian.png" alt="" style="width: 20px; height: 20px">
            <a class="item" :href="footerData.icp" target="_blank">备案号：{{ footerData.publicSecurity }}</a>
          </div>
          <p class="copyright">{{ footerData.copyright }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFooterData } from '@/api/index'

export default {
    name: 'Footer',
    data() {
        return {
            footerData: {
                phone: '',
                email: '',
                address: '',
                weChatImage: '',
                icp: '',
                publicSecurity: '',
                copyright: ''
            }
        };
    },
    mounted() {
        // 获取缓存的数据
        const cachedFooterData = localStorage.getItem('footerData');
        // 如果有缓存的数据，则使用缓存的数据
        if (cachedFooterData) {
            this.footerData = JSON.parse(cachedFooterData);
        }
    },
};
</script>

<style lang="scss" scoped>
.footer {
  //background: rgba(233, 233, 233, 0.99);
  padding: 30px 0;
  width: 100vw;
  margin: 0 auto;

  .other {
    .img {
      margin: 0 10px;
    }

    .item {
      color: #606266;
      font-size: 14px;
      line-height: 30px;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    .copyright {
      color: #606266;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .container {
    .info {
      line-height: 30px;

      .el-icon-location-information, .el-icon-message, .el-icon-phone {
        margin-right: 5px;
      }

      .el-icon-location-information {
        margin-left: -1px;
      }
    }
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 10px;
    }
    .info {
      font-size: 12px;
    }
    .other {
      .item, .copyright {
        font-size: 12px;
      }
    }
  }
}
</style>
